import { graphql, useFragment } from "react-relay";
import { CalendarTeamEventItem_event$key } from "./__generated__/CalendarTeamEventItem_event.graphql";
import { AHText, Box, Circle } from "arkh";
import { CalendarOverviewEventItemDateTime } from "widgets/src/WidgetCalendarOverview/CalendarOverviewEventItemDateTime";

export function CalendarTeamEventItem(props: {
  event: CalendarTeamEventItem_event$key;
  isActive: boolean;
}) {
  const event = useFragment(
    graphql`
      fragment CalendarTeamEventItem_event on CalendarEvent {
        title
        storeCalendar {
          color
        }
        ...CalendarOverviewEventItemDateTime_event
      }
    `,
    props.event
  );

  return (
    <Box style={{ flexDirection: "row", alignItems: "flex-start" }}>
      <Circle
        size="badge"
        style={{
          backgroundColor: event.storeCalendar.color,
          marginTop: 3,
        }}
      />
      <AHText type="subtitle" spaceLeft="small" style={{ flex: 1 }}>
        {event.title}
      </AHText>
      <AHText
        type="detail"
        spaceLeft="small"
        color={props.isActive ? "primary" : "text-secondary"}
        style={{ marginTop: 2 }}
      >
        <CalendarOverviewEventItemDateTime event={event} />
      </AHText>
    </Box>
  );
}
